/**
 * @ngdoc overview
 * @name evtviewer.analogue
 * @description 
 * # evtviewer.analogue
 * Module referring to analogues.
 * 
 * ## Services
 * - {@link evtviewer.analogue.evtAnalogue evtAnalogue} where the scope of 
 * {@link evtviewer.analogue.directive:evtAnalogue evtAnalogue} directive is expanded and stored untill the directive remains instantiated.
 *
 * ## Directives
 * - {@link evtviewer.analogue.directive:evtAnalogue evtAnalogue}: custom directive that will show the content of an analogue
 *
 * ## Controllers
 * - {@link evtviewer.analogue.controller:AnalogueCtrl AnalogueCtrl}: controller for the 
 * {@link evtviewer.analogue.directive:evtAnalogue evtAnalogue} directive.
**/
angular.module('evtviewer.analogue', []);